<template>
    <div>
        <div class="pl-3 pr-3 border-solid border-gray-200 border-2" v-if="(mode === 'NEW') || (mode === 'EDIT')">
            <v-form ref="myform" v-model="isformvalid">
                <v-jsf v-model="formmodel" :schema="formschema" :options="formoptions">
                    <template slot="orderno" slot-scope="context">
                        <v-text-field v-bind="context" v-model="formmodel.orderno" autofocus maxlength="16" :readonly="fieldlocked"></v-text-field>
                    </template>
                    <template slot="cafsno" slot-scope="context">
                        <v-text-field v-bind="context" v-model="formmodel.cafsno" maxlength="15" :readonly="fieldlocked"></v-text-field>
                    </template>
                    <template slot="ordertype" slot-scope="context">
                        <v-select v-bind="context" v-model="formmodel.ordertype" :items="ddordertypes" item-value="id" item-text="description" :readonly="fieldlocked"></v-select>
                    </template>
                    <template slot="svcno" slot-scope="context">
                        <v-text-field v-bind="context" v-model="formmodel.svcno" maxlength="15" :readonly="fieldlocked"></v-text-field>
                    </template>
                    <template slot="svctype" slot-scope="context">
                        <v-radio-group v-bind="context" label="" v-model="formmodel.svctype" row dense>
                            <v-radio label="HSBA" value="HSBA"></v-radio>
                            <v-radio label="HSBB" value="HSBB"></v-radio>
                        </v-radio-group>
                    </template>
                    <template slot="remarks" slot-scope="context">
                        <v-textarea v-bind="context" v-model="formmodel.remarks" :readonly="fieldlocked"></v-textarea>
                    </template>
                    <template slot="orderstatus" slot-scope="context">
                        <v-select v-bind="context" v-model="formmodel.orderstatus" :items="ddorderstatus" item-value="id" item-text="description" :readonly="fieldlocked"></v-select>
                    </template>
                    <template slot="bpid" slot-scope="context">
                        <v-select v-bind="context" :items="ddbizpartners" v-model="formmodel.bpid" item-text="company" item-value="id"></v-select>
                    </template>
                    <template slot="bpopid" slot-scope="context">
                        <v-select v-bind="context" :items="ddoperators" v-model="formmodel.bpopid" item-text="name" item-value="id"></v-select>
                    </template>
                    <template slot="ordertotalcost" slot-scope="{ label, context }">
                        <v-text-field v-bind="context" v-model="formmodel.ordertotalcost" prefix="RM " :label="label" readonly></v-text-field>
                        <br>
                    </template>
                    <template slot="region" slot-scope="context">
                        <v-select v-bind="context" :items="ddorderregions" v-model="formmodel.region" item-text="description" item-value="id"></v-select>
                    </template>
                    <template slot="dummyextras" slot-scope="context">
                        <v-row v-bind="context" no-gutters>
                            <v-col cols="12">
                                <span class="font-bold">Extra Charges</span>
                            </v-col>
                            <v-col cols="10" class="pr-2">
                                <v-select v-model="selorderextra" label="Extra Charge" ref="fldorderextra" :items="ddorderextras" item-value="id" item-text="description"></v-select>
                            </v-col>
                            <v-col cols="2" class="d-flex items-end mb-5">
                                <v-btn dark color="primary" v-bind="context" @click="addextracharge()">Add</v-btn>
                            </v-col>
                            <v-col cols="12">
                                <v-simple-table dense>
                                    <template>
                                        <thead class="bg-gray-700">
                                            <tr>
                                                <th width="65%"><span class="text-white">Description</span></th>
                                                <th width="25%" class="text-right"><span class="text-white">Cost</span></th>
                                                <th width="10%" class="text-left"><span class="text-white">Action</span></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="itm in orderextras" :key="itm.no">
                                                <td class="text-left border-b-2 border-l-2 border-solid border-black">{{ itm.description }}</td>
                                                <td class="text-right border-b-2 border-solid border-black">{{ parseFloat(itm.orcost).toFixed(2) }}</td>
                                                <td class="text-left border-b-2 border-r-2 border-solid border-black">
                                                    <v-tooltip bottom>
                                                        <template v-slot:activator="{ on, attrs }">
                                                            <v-btn small v-bind="attrs" v-on="on" icon @click="removeextracharge(itm)">
                                                                <v-icon small>mdi-delete</v-icon>
                                                            </v-btn>
                                                        </template>
                                                        <span>Remove</span>
                                                    </v-tooltip>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </template>
                                </v-simple-table>
                            </v-col>
                        </v-row>
                    </template>
                    <template slot="dummyfiles" slot-scope="context">
                        <v-row v-bind="context" no-gutters>
                            <v-col cols="12">
                                <span class="font-bold">Images</span>
                            </v-col>
                            <v-col cols="12" class="pr-2">
                                <v-file-input v-model="fileuploads" label="Attach Images" accept="image/png, image/jpeg, image/bmp" multiple show-size v-if="$page.props.user.usertype !== 'dataop'"></v-file-input>
                            </v-col>
                            <v-col cols="12">
                                <v-row v-if="mode === 'NEW'" no-gutters>
                                    <v-col cols="6" v-for="itm in fileuploads" :key="itm.name" class="p-2">
                                        <v-img width="100%" :src="getfileurl(itm)"></v-img>
                                    </v-col>
                                </v-row>
                                <v-row v-if="mode === 'EDIT'" no-gutters>
                                    <v-col cols="6" v-for="img in orderimages" :key="img.id" class="p-2">
                                        <v-img width="100%" :src="img.docpath + img.docname"></v-img>
                                        <v-btn small width="100%" dark color="red darken-4" @click="deleteimage(img)">
                                            <v-icon small>
                                                mdi-delete
                                            </v-icon>
                                        </v-btn>
                                    </v-col>
                                    <v-col cols="6" v-for="itm in fileuploads" :key="itm.name" class="p-2">
                                        <v-img width="100%" :src="getfileurl(itm)"></v-img>
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                    </template>
                </v-jsf>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-3" dark @click="savethis()" v-if="mode !== ''">
                        <v-icon left>mdi-content-save</v-icon>
                        Update
                    </v-btn>
                    <v-btn color="red darken-3" dark @click="cancel()" v-if="mode != ''">
                        <v-icon left>mdi-close</v-icon>
                        Cancel
                    </v-btn>
                </v-card-actions>
            </v-form>
        </div>
        <div class="pa-2 mt-3 border-solid border-gray-200 border-2" v-if="mode === ''">
            <v-data-table dense
                :headers="headers"
                :items="filtereddata()"
                item-key="id"
                v-model="selecteditems"
                show-select
                :items-per-page="50"
                no-data-text="No record"
                no-results-text="No record"
                :footer-props="{
                    'items-per-page-options': [ 10, 20, 30, 40, 50 ]
                }"
            >
                <template v-slot:top>
                    <v-toolbar flat color="white">
                        <v-spacer></v-spacer>
                        <v-btn color="primary" dark class="mb-2" @click="addItem">New</v-btn>
                    </v-toolbar>
                </template>
                <template v-slot:[`header.company`]="{ header }">
                    {{ header.text }}
                    <v-menu offset-y :close-on-content-click="false" min-width="300">
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn icon v-bind="attrs" v-on="on">
                                <v-icon small :color="filterfields.txtcompany ? 'primary' : ''">mdi-filter</v-icon>
                            </v-btn>
                        </template>
                        <div class="bg-white pa-2">
                            <v-text-field v-model="filterfields.txtcompany" label="Business Partner" outlined dense></v-text-field>
                            <v-btn @click="filterfields.txtcompany = ''" small text color="primary" class="ml-2 mb-2">Clear</v-btn>
                        </div>
                    </v-menu>
                </template>
                <template v-slot:[`header.operator`]="{ header }">
                    {{ header.text }}
                    <v-menu offset-y :close-on-content-click="false" min-width="300">
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn icon v-bind="attrs" v-on="on">
                                <v-icon small :color="filterfields.txtoperator ? 'primary' : ''">mdi-filter</v-icon>
                            </v-btn>
                        </template>
                        <div class="bg-white pa-2">
                            <v-text-field v-model="filterfields.txtoperator" label="Operator" outlined dense></v-text-field>
                            <v-btn @click="filterfields.txtoperator = ''" small text color="primary" class="ml-2 mb-2">Clear</v-btn>
                        </div>
                    </v-menu>
                </template>
                <template v-slot:[`header.orderno`]="{ header }">
                    {{ header.text }}
                    <v-menu offset-y :close-on-content-click="false" min-width="300">
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn icon v-bind="attrs" v-on="on">
                                <v-icon small :color="filterfields.txtorderno ? 'primary' : ''">mdi-filter</v-icon>
                            </v-btn>
                        </template>
                        <div class="bg-white pa-2">
                            <v-text-field v-model="filterfields.txtorderno" label="Order No." outlined></v-text-field>
                            <v-btn @click="filterfields.txtorderno = ''" small text color="primary" class="ml-2 mb-2">Clear</v-btn>
                        </div>
                    </v-menu>
                </template>
                <template v-slot:[`header.cafsno`]="{ header }">
                    {{ header.text }}
                    <v-menu offset-y :close-on-content-click="false" min-width="300">
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn icon v-bind="attrs" v-on="on">
                                <v-icon small :color="filterfields.txtcafsno ? 'primary' : ''">mdi-filter</v-icon>
                            </v-btn>
                        </template>
                        <div class="bg-white pa-2">
                            <v-text-field v-model="filterfields.txtcafsno" label="CAF No." outlined dense></v-text-field>
                            <v-btn @click="filterfields.txtcafsno = ''" small text color="primary" class="ml-2 mb-2">Clear</v-btn>
                        </div>
                    </v-menu>
                </template>
                <template v-slot:[`header.svcno`]="{ header }">
                    {{ header.text }}
                    <v-menu offset-y :close-on-content-click="false" min-width="300">
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn icon v-bind="attrs" v-on="on">
                                <v-icon small :color="filterfields.txtsvcno ? 'primary' : ''">mdi-filter</v-icon>
                            </v-btn>
                        </template>
                        <div class="bg-white pa-2">
                            <v-text-field v-model="filterfields.txtsvcno" label="Service No." outlined dense></v-text-field>
                            <v-btn @click="filterfields.txtsvcno = ''" small text color="primary" class="ml-2 mb-2">Clear</v-btn>
                        </div>
                    </v-menu>
                </template>
                <template v-slot:[`header.region`]="{ header }">
                    {{ header.text }}
                    <v-menu offset-y :close-on-content-click="false" min-width="300">
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn icon v-bind="attrs" v-on="on">
                                <v-icon small :color="filterfields.txtregion ? 'primary' : ''">mdi-filter</v-icon>
                            </v-btn>
                        </template>
                        <div class="bg-white pa-2">
                            <v-text-field v-model="filterfields.txtregion" label="Region" outlined dense></v-text-field>
                            <v-btn @click="filterfields.txtregion = ''" small text color="primary" class="ml-2 mb-2">Clear</v-btn>
                        </div>
                    </v-menu>
                </template>
                <template v-slot:[`header.dateinstall`]="{ header }">
                    {{ header.text }}
                    <v-menu offset-y :close-on-content-click="false" min-width="300">
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn icon v-bind="attrs" v-on="on">
                                <v-icon small :color="filterfields.txtdateinstall ? 'primary' : ''">mdi-filter</v-icon>
                            </v-btn>
                        </template>
                        <div class="bg-white pa-2">
                            <v-text-field v-model="filterfields.txtdateinstall" label="Date Install" hint="YYYY-MM-DD" outlined dense></v-text-field>
                            <v-btn @click="filterfields.txtdateinstall = ''" small text color="primary" class="ml-2 mb-2">Clear</v-btn>
                        </div>
                    </v-menu>
                </template>
                <template v-slot:[`item.no`]="{ item }">
                    <small>{{ dataitems.indexOf(item) + 1 }}</small>
                </template>
                <template v-slot:[`item.company`]="{ item }">
                    <small>{{ item.company }}</small>
                </template>
                <template v-slot:[`item.operator`]="{ item }">
                    <small>{{ item.operator }}</small>
                </template>
                <template v-slot:[`item.orderno`]="{ item }">
                    <small>{{ item.orderno }}</small>
                </template>
                <template v-slot:[`item.cafsno`]="{ item }">
                    <small>{{ item.cafsno }}</small>
                </template>
                <template v-slot:[`item.svcno`]="{ item }">
                    <small>{{ item.svcno }}</small>
                </template>
                <template v-slot:[`item.ordertype`]="{ item }">
                    <small>{{ item.ordertype }} - {{ item.ordertypedesc }}</small>
                </template>
                <template v-slot:[`item.orderstatus`]="{ item }">
                    <small>{{ item.orderstatus }} - {{ item.orderstatusdesc }}</small>
                </template>
                <template v-slot:[`item.region`]="{ item }">
                    <small>{{ item.region }}</small>
                </template>
                <template v-slot:[`item.dateinstall`]="{ item }">
                    <small>{{ $moment(item.dateinstall).format('DD/MM/YYYY') }}</small>
                </template>
                <template v-slot:[`item.created_at`]="{ item }">
                    <small>{{ $moment(item.created_at).format('DD/MM/YYYY h:mm A') }}</small>
                </template>
                <template v-slot:[`item.actions`]="{ item }">
                    <v-icon class="mr-2" small color="black" @click="editItem(item)">mdi-pencil</v-icon>
                    <v-icon color="black" small @click="deleteItem(item)">mdi-delete</v-icon>
                </template>
                <template v-slot:[`body.append`]>
                    <td colspan="6">
                        <v-select class="w-40 mt-3" :items="multifunctions" item-value="type" item-text="name" v-model="selmultifunc" placeholder="Bulk Operation" @change="execmfunc" dense/>
                    </td>
                </template>
            </v-data-table>
        </div>
        <v-dialog v-model="dlgdelete" width="450" v-if="dlgdelete" dark dense>
            <v-card dense>
                <v-card-title class="title"><span class="text-white">Delete this record?</span></v-card-title>
                <v-card-text>
                    <v-row dense>
                        <v-col cols="4">No.</v-col>
                        <v-col cols="8">{{ deleteditem.no }}</v-col>
                        <v-col cols="4">Order No.</v-col>
                        <v-col cols="8">{{ deleteditem.orderno }}</v-col>
                        <v-col cols="4">Order Type</v-col>
                        <v-col cols="8">{{ getdesc_ordertype(deleteditem.ordertype) }}</v-col>
                        <v-col cols="4">Date Install</v-col>
                        <v-col cols="8">{{ $moment(deleteditem.dateinstall).format('DD/MM/YYYY') }}</v-col>
                        <v-col cols="4">Service No.</v-col>
                        <v-col cols="8">{{ deleteditem.svcno }}</v-col>
                        <v-col cols="4">Service Type</v-col>
                        <v-col cols="8">{{ deleteditem.svctype }}</v-col>
                        <v-col cols="4">CAF Serial No.</v-col>
                        <v-col cols="8">{{ deleteditem.cafsno }}</v-col>
                        <v-col cols="4">Order Status</v-col>
                        <v-col cols="8">{{ getdesc_orderstatus(deleteditem.orderstatus) }}</v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-3" dark @click="deletethis()">
                        <v-icon left>mdi-delete</v-icon>
                        Delete
                    </v-btn>
                    <v-btn color="red darken-3" dark @click="canceldelete()">
                        <v-icon left>mdi-close</v-icon>
                        Cancel
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-snackbar v-model="sbmsg" timeout="5000" color="green darken-4" dark centered>
            <div v-html="msg"></div>
            <template v-slot:action="{ attrs }">
                <v-btn color="white" text v-bind="attrs" @click="sbmsg = false">
                    Close
                </v-btn>
            </template>
        </v-snackbar>
        <v-snackbar v-model="sberrmsg" timeout="5000" color="red darken-4" dark centered>
            <div v-html="msg"></div>
            <template v-slot:action="{ attrs }">
                <v-btn color="white" text v-bind="attrs" @click="sberrmsg = false">
                    Close
                </v-btn>
            </template>
        </v-snackbar>
    </div>
</template>

<script>
const axios = require('axios')
import GeneralOptions from '../Forms/GeneralOptions'
import CustomerOrdersAdminModel from '../Forms/CustomerOrdersAdminModel'
import CustomerOrdersAdminSchema from '../Forms/CustomerOrdersAdminSchema'

export default {
    name: 'TableCustomerOrdersAdmin',
    components: {},
    props: {},
    data() {
        return {
            isformvalid: false,
            formoptions: GeneralOptions,
            formmodel: CustomerOrdersAdminModel,
            formschema: CustomerOrdersAdminSchema,
            dataitems: [],
            headers: [
                { text: "No.",              value: "no",            sortable: false, align: "start", width: '40px' },
                { text: "Business Partner", value: "company",       sortable: false },
                { text: "Operator",         value: "operator",      sortable: false },
                { text: "Order No.",        value: "orderno",       sortable: false },
                { text: "CAF No.",          value: "cafsno",        sortable: false },
                { text: "Service No.",      value: "svcno",         sortable: false },
                { text: "Order Type",       value: "ordertype",     sortable: false },
                { text: "Order Status",     value: "orderstatus",   sortable: false },
                { text: "Region",           value: "region",        sortable: false },
                { text: "Date Install",     value: "dateinstall",   sortable: false },
                { text: "Date Submit",      value: "created_at",    sortable: false },
                { text: "Operations",       value: "actions",       sortable: false, align: 'end', width: '100px' }
            ],
            mode: null,
            editeditem: {
                no: 0,
                id: 0,
                orderno: '',
                cafsno: '',
                svcno: '',
                svctype: '',
                ordertype: '',
                dateinstall: '',
                bpid: '',
                bpopid: '',
                remarks: '',
                ordertotalcost: '',
                orderstatus: '',
                region: '',
            },
            deleteditem: {
                no: 0,
                id: 0,
                orderno: '',
                cafsno: '',
                svcno: '',
                svctype: '',
                ordertype: '',
                dateinstall: '',
                bpid: '',
                bpopid: '',
                remarks: '',
                ordertotalcost: '',
                orderstatus: '',
                region: '',
            },
            newitem: {
                orderno: '',
                cafsno: '',
                svcno: '',
                svctype: '',
                ordertype: '',
                dateinstall: '',
                bpid: '',
                bpopid: '',
                remarks: '',
                ordertotalcost: '',
                orderstatus: '',
                region: '',
            },
            dlgdelete: false,
            sbmsg: false,
            sberrmsg: false,
            msg: '',
            selecteditems: [],
            multifunctions: [
                // multi selection functions
                { type: null, name: 'Bulk Operation' }, // default
                { type: 'MDEL', name: 'Delete selected' },
            ],
            selmultifunc: null,
            ismounted: false,
            fieldlocked: false,
            filterfields: {
                txtcompany: '',
                txtoperator: '',
                txtorderno: '',
                txtcafsno: '',
                txtsvcno: '',
                txtregion: '',
                txtdateinstall: '',
            },
            orderextras: [],
            orderimages: [],
            ddordertypes: [],
            ddorderstatus: [],
            ddorderregions: [],
            ddbizpartners: [],
            ddoperators: [],
            ddorderextras: [],
            selorderextra: null,
            fileuploads: [],
            previewfiles: [],
        }
    },
    watch: {
        mode: function (newval, oldval) {
            if (newval === '')  {
                // lock the form entry
                this.lockallfields(true)
                return
            }
            if (((newval === 'NEW') || (newval === 'EDIT')) && (oldval === '')) {
                // unlock the form entry
                this.lockallfields(false)
                return
            }
        },
        'formmodel.bpid': function (newval, oldval) {
            if (newval) {
                this.getoperators(newval)
            }
        },
        'formmodel.ordertype': function (newval, oldval) {
            if (newval) {
                this.gettotalcost(newval)
            }
        },
        orderextras: function (newval, oldval) {
            if (newval) {
                if (this.formmodel.ordertype !== '') {
                    this.gettotalcost(this.formmodel.ordertype)
                }
            }
        },
        fileuploads: function (newval, oldval) {
            var itm = {}
            this.previewfiles = []
            for (var i=0 ; i < newval.length; i++) {
                itm = { name: newval[i].name, url: URL.createObjectURL(newval[i]) }
                this.previewfiles.push(itm)
            }
        },
    },
    mounted: function () {
        this.initialize()
    },
    methods: {
        lockallfields(pSwitch) {
            this.fieldlocked = pSwitch // any custom field
            const vjsfprops = this.formschema.properties
            for (const field in vjsfprops) {
                if (vjsfprops[field]['x-props']) {
                    vjsfprops[field]['x-props']['readonly'] = pSwitch
                }
            }
        },

        initialize() {
            this.$nextTick(() => {
                this.getdata()
                this.ismounted = true
                this.mode = ''
                this.editeditem = Object.assign({}, this.newitem)
                this.formmodel = Object.assign({}, this.newitem)
                this.selecteditems = []
                this.multifunc = ''

                this.fileuploads = []
                this.previewfiles = []
                this.orderextras = []
                this.selorderextra = null

                this.filterfields.txtorderno = ''
                this.filterfields.txtcafsno = ''
                this.filterfields.txtsvcno = ''

                this.getordertypes()
                this.getorderstatus()
                this.getorderregions()
                this.getbizpartners()
                this.getorderextras()
            })
        },

        getdata() {
            var targetPath = '/admin/customer-orders/all'
            axios.get(targetPath)
            .then((resp) => {
                if (resp.data) {
                    var rtn = resp.data
                    if (rtn.status === 'OK') {
                        this.dataitems = rtn.data
                    } else {
                        this.dataitems = []
                    }
                }
            })
        },

        getordertypes() {
            var targetPath = '/admin/customer-orders/dd-ordertypes'
            axios.get(targetPath)
            .then((resp) => {
                if (resp.data) {
                    var rtn = resp.data
                    if (rtn.status === 'OK') {
                        this.ddordertypes = rtn.data
                    } else {
                        this.ddordertypes = []
                    }
                }
            })
        },

        getorderstatus() {
            var targetPath = '/admin/customer-orders/dd-orderstatus'
            axios.get(targetPath)
            .then((resp) => {
                if (resp.data) {
                    var rtn = resp.data
                    if (rtn.status === 'OK') {
                        this.ddorderstatus = rtn.data
                    } else {
                        this.ddorderstatus = []
                    }
                }
            })
        },

        getorderregions() {
            var targetPath = '/admin/customer-orders/dd-orderregions'
            axios.get(targetPath)
            .then((resp) => {
                if (resp.data) {
                    var rtn = resp.data
                    if (rtn.status === 'OK') {
                        this.ddorderregions = rtn.data
                    } else {
                        this.ddorderregions = []
                    }
                }
            })
        },

        getorderextras() {
            var targetPath = '/admin/customer-orders/dd-orderextras'
            axios.get(targetPath)
            .then((resp) => {
                if (resp.data) {
                    var rtn = resp.data
                    if (rtn.status === 'OK') {
                        this.ddorderextras = rtn.data
                    } else {
                        this.ddorderextras = []
                    }
                }
            })
        },

        getbizpartners() {
            var targetPath = '/admin/customer-orders/dd-bizpartners'
            axios.get(targetPath)
            .then((resp) => {
                if (resp.data) {
                    var rtn = resp.data
                    if (rtn.status === 'OK') {
                        this.ddbizpartners = rtn.data
                    } else {
                        this.ddbizpartners = []
                    }
                    this.ddoperators = []
                }
            })
        },

        getoperators(pBPid) {
            var targetPath = '/admin/customer-orders/dd-operators/' + pBPid
            axios.get(targetPath)
            .then((resp) => {
                if (resp.data) {
                    var rtn = resp.data
                    if (rtn.status === 'OK') {
                        this.ddoperators = rtn.data
                    } else {
                        this.ddoperators = []
                    }
                }
            })
        },

        gettotalcost(pOrderType) {
            var totalcost = 0.00

            if (this.ddordertypes.length > 0) {
                var rtnobj = this.ddordertypes.find(obj => {
                    return obj.id === pOrderType
                })
                if (rtnobj) {
                    totalcost = parseFloat(rtnobj.otcost)
                }
            }

            if (this.orderextras.length > 0) {
                var totalextras = (this.orderextras) ? this.orderextras.reduce((a, b) => a + (Number(b['orcost']) || 0), 0.00) : 0.00
                totalcost += totalextras
            }

            this.formmodel.ordertotalcost = totalcost
        },

        getcustorderextras(pOrderID) {
            var targetPath = '/admin/customer-orders/' + pOrderID.toString() + '/ordertextras'
            axios.get(targetPath)
            .then((resp) => {
                if (resp.data) {
                    var rtn = resp.data
                    if (rtn.status === 'OK') {
                        this.orderextras = rtn.data
                        this.gettotalcost(this.formmodel.ordertype)
                    } else {
                        this.orderextras = []
                    }
                }
            })
        },

        getcustorderimages(pOrderID) {
            var targetPath = '/admin/customer-orders/' + pOrderID.toString() + '/images'
            axios.get(targetPath)
            .then((resp) => {
                if (resp.data) {
                    var rtn = resp.data
                    if (rtn.status === 'OK') {
                        this.orderimages = rtn.data
                    } else {
                        this.orderimages = []
                    }
                }
            })
        },

        getfileurl(pItem) {
            var rtnobj = this.previewfiles.find(obj => {
                return obj.name === pItem.name
            })
            return rtnobj.url
        },

        getdesc_bizpartner(pBPID) {
            var rtnobj = this.ddbizpartners.find(obj => {
                if (obj.id === parseInt(pBPID)) return obj
            })
            return rtnobj.company
        },

        getdesc_operator(pOPID) {

            var rtnobj = this.ddoperators.find(obj => {
                if (obj.id === parseInt(pOPID)) return obj
            })
            console.log(rtnobj)
            return rtnobj.name
        },

        getdesc_ordertype(pOrderType) {
            var rtnobj = this.ddordertypes.find(obj => {
                if (obj.id === pOrderType) return obj
            })
            return rtnobj.description
        },

        getdesc_orderstatus(pOrderStatus) {
            var rtnobj = this.ddorderstatus.find(obj => {
                if (obj.id === pOrderStatus) return obj
            })
            return rtnobj.description
        },

        filtereddata() {
            var conditions = []

            if (this.filterfields.txtcompany) { conditions.push(this.filtercompany) }
            if (this.filterfields.txtoperator) { conditions.push(this.filteroperator) }
            if (this.filterfields.txtorderno) { conditions.push(this.filterorderno) }
            if (this.filterfields.txtcafsno) { conditions.push(this.filtercafsno) }
            if (this.filterfields.txtregion) { conditions.push(this.filterregion) }
            if (this.filterfields.txtdateinstall) { conditions.push(this.filterdateinstall) }

            if (conditions.length > 0) {
                return this.dataitems.filter((item) => {
                    return conditions.every((condition) => {
                        return condition(item)
                    })
                })
            }

            return this.dataitems
        },

        filtercompany(item) {
            return (item.company) ? item.company.toLowerCase().includes(this.filterfields.txtcompany.toLowerCase()) : null
        },

        filteroperator(item) {
            return (item.operator) ? item.operator.toLowerCase().includes(this.filterfields.txtoperator.toLowerCase()) : null
        },

        filterorderno(item) {
            return (item.orderno) ? item.orderno.toLowerCase().includes(this.filterfields.txtorderno.toLowerCase()) : null
        },

        filtercafsno(item) {
            return (item.cafsno) ? item.cafsno.toLowerCase().includes(this.filterfields.txtcafsno.toLowerCase()) : null
        },

        filterregion(item) {
            return (item.region) ? item.region.toLowerCase().includes(this.filterfields.txtregion.toLowerCase()) : null
        },

        filterdateinstall(item) {
            return (item.dateinstall) ? item.dateinstall.includes(this.filterfields.txtdateinstall) : null
        },

        canceldelete() {
            this.deleteditem = Object.assign({}, this.newitem)
            this.dlgdelete = false
            this.cancel()
        },

        cancel() {
            this.editeditem = Object.assign({}, this.newitem)
            this.formmodel = Object.assign({}, this.newitem)
            this.fileuploads = []
            this.previewfiles = []
            this.orderextras = []
            this.selorderextra = null
            this.mode = ''
        },

        addItem() {
            // check permission
            if (this.$page.props.user.usertype === 'dataop') {
                this.msg = 'You do not have permission to add new record'
                this.sberrmsg = true
                return
            }

            this.editeditem = Object.assign({}, this.newitem)
            this.formmodel = Object.assign({}, this.newitem)

            // populate dummy data
            // this.formmodel.orderno = '0000000001'
            // this.formmodel.cafsno = '000000000000001'
            // this.formmodel.svcno = '0123456789'
            // this.formmodel.svctype = 'HSBB'
            // this.formmodel.ordertype = '01'
            // this.formmodel.remarks = 'The quick brown fox jumps over the fence.'
            // this.formmodel.dateinstall = this.$moment(new Date).format('YYYY-MM-DD')
            // this.formmodel.orderstatus = '01'
            // this.formmodel.bpid = 1
            // this.formmodel.bpopid = 2

            this.fileuploads = []
            this.previewfiles = []
            this.orderextras = []
            this.selorderextra = null
            this.mode = 'NEW'
        },

        editItem(pItem) {
            this.getoperators(parseInt(pItem.bpid))
            this.getcustorderextras(pItem.id)
            this.getcustorderimages(pItem.id)

            this.editeditem = Object.assign({}, pItem)
            this.formmodel = Object.assign({}, this.editeditem)

            this.mode = 'EDIT'
        },

        deleteItem(pItem) {
            if (this.$page.props.user.usertype === 'dataop') {
                this.msg = 'You do not have permission to delete record'
                this.sberrmsg = true
                return
            }

            this.deleteditem = Object.assign({}, pItem)
            this.deleteditem.no = this.dataitems.indexOf(pItem) + 1
            this.dlgdelete = true
        },

        removeextracharge(pItem) {
            if (this.$page.props.user.usertype === 'dataop') {
                this.msg = 'You do not have permission to use this function'
                this.sberrmsg = true
                return
            }

            var ndx = this.orderextras.indexOf(pItem)
            this.orderextras.splice(ndx, 1)
        },

        addextracharge() {
            if (this.$page.props.user.usertype === 'dataop') {
                this.msg = 'You do not have permission to use this function'
                this.sberrmsg = true
                return
            }

            if (!this.selorderextra) {
                this.msg = 'Must select the extra charge first'
                this.sberrmsg = true
                this.$refs.fldorderextra.focus()
                return
            }
            var rtnobj = this.ddorderextras.find(obj => {
                return obj.id === this.selorderextra
            })

            var tmp_id = 0
            var tmp_oid = 0
            var tmp_desc = ''
            var tmp_orid = 0
            var tmp_orprice = 0


            tmp_orid = rtnobj.id
            tmp_id = this.orderextras.length + 1
            tmp_orprice = parseFloat(rtnobj.orprice)
            tmp_desc = rtnobj.description

            if (this.mode === 'NEW') {
                tmp_oid = 0
            } else {
                tmp_oid = this.editeditem.id
            }
            let itm = { id: tmp_id, oid: tmp_oid, orid: tmp_orid, orcost: tmp_orprice, description: tmp_desc }
            this.orderextras.push(itm)
        },

        savethis() {
            var targetPath = ''

            // check permission
            if (this.$page.props.user.usertype === 'dataop') {
                this.msg = 'You do not have permission to update record'
                this.sberrmsg = true
                return
            }

            if (!this.isformvalid) {
                this.msg = 'Form contains invalid data. Unable to submit. Make sure all mandatory fields are completed.'
                this.sberrmsg = true
                return
            }

            this.gettotalcost(this.formmodel.ordertype) // recalculate total cost

            let data = new FormData()
            if (this.mode === 'NEW') {
                targetPath = '/admin/customer-orders/add'
            }

            if (this.mode === 'EDIT') {
                targetPath = '/admin/customer-orders/update'
                data.append('id', parseInt(this.editeditem.id))
            }

            data.append('orderno', this.formmodel.orderno)
            data.append('cafsno', this.formmodel.cafsno)
            data.append('svcno', this.formmodel.svcno)
            data.append('svctype', this.formmodel.svctype)
            data.append('ordertype', this.formmodel.ordertype)
            data.append('dateinstall', this.formmodel.dateinstall)
            data.append('bpid', this.formmodel.bpid)
            data.append('bpopid', this.formmodel.bpopid)
            data.append('remarks', this.formmodel.remarks)
            data.append('ordertotalcost', this.formmodel.ordertotalcost)
            data.append('orderstatus', this.formmodel.orderstatus)
            data.append('region', this.formmodel.region)

            if (this.orderextras.length > 0) {
                data.append('orderextras', JSON.stringify(this.orderextras))
            }

            if (this.fileuploads.length > 0) {
                for (let i=0; i<this.fileuploads.length; i++) {
                    data.append('orderfiles[' + i.toString() + ']', this.fileuploads[i])
                }
            }

            axios.post(targetPath, data, {
               headers: { 'Content-Type': 'multipart/form-data' }
            })
            .then((resp) => {
                if (resp.data) {
                    var rtn = resp.data
                    if (rtn.status === 'OK') {
                        this.msg = rtn.message
                        this.sbmsg = true
                        this.initialize()
                    } else {
                        this.msg = rtn.error
                        this.sberrmsg = true
                        this.cancel()
                    }
                }
            })

        },

        deleteimage(pItem) {
            // check permission
            if (this.$page.props.user.usertype === 'dataop') {
                this.msg = 'You do not have permission to use this function'
                this.sberrmsg = true
                return
            }

            var targetPath = '/admin/customer-orders/image/delete'
            var data = { id: pItem.id, }

            axios.post(targetPath, data)
            .then((resp) => {
                if (resp.data) {
                    var rtn = resp.data
                    if (rtn.status === 'OK') {
                        this.getcustorderimages(this.editeditem.id)
                    } else {
                        this.msg = rtn.error
                        this.sberrmsg = true
                    }
                }
            })
        },

        deletethis() {

            var targetPath = '/admin/customer-orders/delete'
            var data = {
                id: this.deleteditem.id,
            }

            axios.post(targetPath, data)
            .then((resp) => {
                if (resp.data) {
                    var rtn = resp.data
                    this.canceldelete()
                    if (rtn.status === 'OK') {
                        this.msg = rtn.message
                        this.sbmsg = true
                        this.initialize()
                    } else {
                        this.msg = rtn.error
                        this.sberrmsg = true
                    }
                }
            })
        },

        execmfunc() {
            // check permission
            if (this.$page.props.user.usertype === 'dataop') {
                this.msg = 'You do not have permission to use this function'
                this.sberrmsg = true
                return
            }

            if (this.selmultifunc === 'MDEL') { // multiple delete
                // check if anything was selected
                if (this.selecteditems.length === 0) {
                    this.msg = 'No records are selected for deletion'
                    this.sberrmsg = true
                    this.$nextTick(() => {
                        this.selmultifunc = null // reset
                    })
                    return
                }
                this.deleteselected()
            }
        },

        deleteselected() {
            var targetPath = '/admin/customer-orders/deleteselected'
            var data = new FormData()

            data.append('todelete', JSON.stringify(this.selecteditems))

            axios.post(targetPath, data, {
                headers: {
                    'ContentType': 'application/json' // coz we're passing an array
                }
            })
            .then((resp) => {
                if (resp.data) {
                    var rtn = resp.data
                    if (rtn.status === 'OK') {
                        this.initialize()
                        this.msg = rtn.message
                        this.sbmsg = true
                    } else {
                        this.msg = rtn.error
                        this.sberrmsg = true
                    }
                    this.$nextTick(() => {
                        this.selmultifunc = null // reset
                        this.selecteditems = [] // reset
                    })
                }
            })
        },
    },
}
</script>

<style>

</style>
